import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Globe, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const brandCategories = [
    { name: "Home & Living", href: "/brands?filter=home" },
    { name: "Garden", href: "/brands?filter=garden" },
    { name: "Pet", href: "/brands?filter=pet" },
    { name: "DIY", href: "/brands?filter=diy" },
    { name: "Health", href: "/brands?filter=health" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-dreibach-black/95 backdrop-blur-md py-4 border-b border-white/10" : "bg-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-6 flex justify-between items-center">
        {/* Left: Logo */}
        <Link to="/" className="flex items-center gap-2 group z-50 relative">
           <Globe className="w-6 h-6 text-white group-hover:text-dreibach-teal transition-colors" />
           <span className="text-2xl font-black tracking-[0.2em] text-white">DREIBACH</span>
        </Link>

        {/* Center: Navigation */}
        <div className="hidden lg:flex items-center justify-center flex-1 ml-12">
          <NavigationMenu>
            <NavigationMenuList className="gap-8">
              <NavigationMenuItem>
                <Link to="/" className={`text-xs font-bold uppercase tracking-widest hover:text-dreibach-teal transition-colors ${location.pathname === "/" ? "text-dreibach-teal" : "text-gray-300"}`}>
                  Home
                </Link>
              </NavigationMenuItem>

              <NavigationMenuItem>
                <Link to="/brands" className={`text-xs font-bold uppercase tracking-widest hover:text-dreibach-teal transition-colors ${location.pathname === "/brands" ? "text-dreibach-teal" : "text-gray-300"}`}>
                  Our Brands & Products
                </Link>
              </NavigationMenuItem>

              {/* <NavigationMenuItem>
                <Link to="/infrastructure" className={`text-xs font-bold uppercase tracking-widest hover:text-dreibach-teal transition-colors ${location.pathname === "/infrastructure" ? "text-dreibach-teal" : "text-gray-300"}`}>
                  Infrastructure
                </Link>
              </NavigationMenuItem> */}

              <NavigationMenuItem>
                <Link to="/our-story" className={`text-xs font-bold uppercase tracking-widest hover:text-dreibach-teal transition-colors ${location.pathname === "/our-story" ? "text-dreibach-teal" : "text-gray-300"}`}>
                  Our Story
                </Link>
              </NavigationMenuItem>

              <NavigationMenuItem>
                <Link to="/responsibility" className={`text-xs font-bold uppercase tracking-widest hover:text-dreibach-teal transition-colors ${location.pathname === "/responsibility" ? "text-dreibach-teal" : "text-gray-300"}`}>
                  Responsibility
                </Link>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        {/* Right: Action */}
        <div className="hidden lg:flex items-center gap-6">
          <Link to="/contact">
             <Button className="bg-white text-black hover:bg-dreibach-teal hover:text-white uppercase tracking-wider font-bold rounded-none px-6 transition-all text-xs">
                Contact Us
             </Button>
          </Link>
          <Link to="/trade/login">
             <Button variant="ghost" className="text-gray-500 hover:text-white hover:bg-transparent uppercase tracking-wider font-bold text-[10px]">
                Trade Login
             </Button>
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden text-white hover:text-dreibach-teal z-50 relative"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-dreibach-black z-40 flex flex-col justify-center px-8 space-y-8 animate-in slide-in-from-top-10 duration-200">
           <Link to="/" onClick={() => setIsOpen(false)} className="text-2xl font-black uppercase text-white hover:text-dreibach-teal">Home</Link>
           
           <div className="space-y-4">
              <span className="text-2xl font-black uppercase text-dreibach-teal">Our Brands & Products</span>
              <div className="pl-4 flex flex-col gap-3 border-l border-white/10">
                 {brandCategories.map(cat => (
                    <Link key={cat.name} to={cat.href} onClick={() => setIsOpen(false)} className="text-lg font-medium uppercase text-gray-400 hover:text-white">{cat.name}</Link>
                 ))}
              </div>
           </div>

           {/* <Link to="/infrastructure" onClick={() => setIsOpen(false)} className="text-2xl font-black uppercase text-white hover:text-dreibach-teal">Infrastructure</Link> */}
           <Link to="/our-story" onClick={() => setIsOpen(false)} className="text-2xl font-black uppercase text-white hover:text-dreibach-teal">Our Story</Link>
           <Link to="/responsibility" onClick={() => setIsOpen(false)} className="text-2xl font-black uppercase text-white hover:text-dreibach-teal">Responsibility</Link>
           <Link to="/contact" onClick={() => setIsOpen(false)} className="text-2xl font-black uppercase text-white hover:text-dreibach-teal">Contact</Link>
           
           <Button className="w-full bg-dreibach-teal text-white uppercase font-bold text-lg py-6 rounded-none mt-8">
              Partner Portal Login
           </Button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
